<template>
  <div class="content-container">
    <!--头部文字-->
    <div class="list-title">
      <el-page-header @back="$router.back()" :content="`${ project.name } - 详情`"></el-page-header>
    </div>
      

    <!--使用文档内容-->
    <div class="content-box">
      <!--http-->
      <div class="http-model" v-show="project.type == 'http'">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold;">HTTP数据上报</span>
          </div>
          <div class="item" style="border: 1px solid rgb(73, 204, 144);">
            接口：
            <el-tag>
              GET
            </el-tag>               
            {{ project.dataUpUrl }}              
            <el-button size="small" type="danger" plain class="demo-btn" v-if="apiDemoVisible" @click="apiDemoVisible=false;">取消测试</el-button>
            <el-button size="small" type="primary" plain class="demo-btn" v-else @click="apiDemoVisible=true;">接口测试</el-button>
          </div>
          <el-row style="font-weight: bold;padding:10px 0;font-size: 14px;">请求参数 : </el-row>
          <div class="item" style="background: rgba(73,204,144,.1);">
            <el-row class="item-title">
              <el-col :span="6">名称</el-col>
              <el-col :span="18">描述</el-col>
            </el-row>
            <!--查询参数-->
            <div>
              <!--api测试-->
              <div v-show="apiDemoVisible">
                <el-row class="item-req">
                  <el-col :span="6">deviceid</el-col>
                  <el-col :span="18">
                    <el-input class="paran-input" v-model="demo.deviceid" placeholder="请输入设备ID"></el-input>
                  </el-col>
                </el-row>
                <el-row class="item-req">
                  <el-col :span="6">realtime</el-col>
                  <el-col :span="18">
                    <!-- <el-input class="paran-input" v-model="demo.realtime" :disabled="true" placeholder="实时数据(获取当前时间延时五秒后的最新数据)"></el-input> -->
                    <el-select v-model="demo.realtime" placeholder="请选择">
                      <el-option
                        v-for="item in realtimeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <el-row class="item-req">
                  <el-col :span="6">time</el-col>
                  <el-col :span="18">
                      <el-input class="paran-input" v-model="demo.time" placeholder="时间戳(秒)"></el-input>
                  </el-col>
                </el-row>
                <el-row class="item-req">
                  <el-col :span="6">interval</el-col>
                  <el-col :span="18">
                      <el-input class="paran-input" v-model="demo.interval" placeholder="时间间隔(秒)"></el-input>
                  </el-col>
                </el-row>
              </div>
              <!--api示例-->
              <div v-show="!apiDemoVisible">
                <el-row class="item-req">
                <el-col :span="6">deviceid</el-col>
                <el-col :span="18">
                    设备ID,查询指定ID的modbus设备。
                </el-col>
              </el-row>
              <el-row class="item-req">
                <el-col :span="6">realtime</el-col>
                <el-col :span="18">
                  实时数据。(realtime=1获取当前时间前五秒的数据,设置后将忽略time与interval参数,不传该参数则正常请求查询)
                </el-col>
              </el-row>
              <el-row class="item-req">
                <el-col :span="6">time</el-col>
                <el-col :span="18">
                    时间戳(秒)，查询指定时间的modbus采集数据。
                </el-col>
              </el-row>
              <el-row class="item-req">
                <el-col :span="6">interval</el-col>
                <el-col :span="18">
                    时间间隔(秒)，与参数time组合使用，查询time ~ (time + interval) 间的modbus采集数据。
                </el-col>
              </el-row>
            </div>
          </div>
            <el-row v-show="apiDemoVisible" style="padding:10px 0;text-align: center;">
              <el-button style="width: 90%;" type="primary" @click="httpDemoTest">执 行</el-button>
            </el-row>
      </div>

          <el-row style="font-weight: bold;padding:10px 0;font-size: 14px;">请求响应 : </el-row>
          <div class="item" style="">
            <!--API测试返回接口-->
            <div v-show="apiDemoVisible">
              <el-row  class="item-title">
                <el-col :span="6">接口测试响应</el-col>
                <el-col :span="18">详情</el-col>
              </el-row>
              <el-row class="item-resp">
                <el-col :span="6">200</el-col>
                <el-col :span="18">
                  <div>
                    <el-input type="textarea" class="textarea" rows="3" v-model="demoResponse"></el-input>
                  </div>
                </el-col>
              </el-row>
            </div>

            <!--API响应描述 v-show="!apiDemoVisible"-->
            <div >
              <el-row class="item-title">
                <el-col :span="6">响应码</el-col>
                <el-col :span="18">描述</el-col>
              </el-row>
              <el-row class="item-resp">
                <el-col :span="6">200</el-col>
                <el-col :span="18">
                  OK
                  <div style="padding: 5px 0;font-weight: bold;">示例值:</div>
                  <div id="monaco2" class="monaco"></div>
                  <div style="padding: 5px 0;font-weight: bold;">响应内容: json字符串</div>
                  <table class="table">
                    <tr>
                      <th width="100px">参数</th>
                      <th width="300px">说明</th>
                    </tr>
                    <tr>
                      <td>code</td>
                      <td>200 成功， 其他 失败</td>
                    </tr>
                    <tr>
                      <td>data</td>
                      <td>响应数据</td>
                    </tr>
                    <tr>
                      <td>msg</td>
                      <td>响应消息内容</td>
                    </tr>
                  </table>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </div>

      <!--webscoket-->
      <div class="websocket-model" v-show="project.type == 'websocket'">
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <span style="font-weight: bold;">WebSocket实时通讯</span>
          </div>
          <div class="item">
            接口：<el-tag>WebSocket</el-tag> {{ project.dataUpUrl }}
            <el-button size="small" type="danger" plain class="demo-btn" v-if="wsDemoVisible" @click="wsDemoVisible=false;">取消测试</el-button>
            <el-button size="small" type="primary" plain class="demo-btn" v-else @click="wsDemoVisible=true;">接口测试</el-button>
          </div>
          <div class="item" style="background: rgba(73,204,144,.1);">
            <!--wesocket测试参数-->
            <div v-show="wsDemoVisible">
              <el-row style="font-weight: bold;padding:10px 0;text-align: end;" v-show="wsDemoVisible">
                <el-button-group>
                  <el-button type="primary" @click="wsDemoConn" v-if="!wsConn"  icon="el-icon-link">连接</el-button>
                  <el-button type="danger" @click="wsDemoClose" v-else icon="el-icon-share">断开</el-button>
                  <el-button @click="wsDemoClear" icon="el-icon-delete">清空</el-button>
                </el-button-group>
              </el-row>                
              <el-row class="item-resp">
                <el-col>
                  <div class="ws-response-div" id="wsoutput">
                    
                  </div>
                </el-col>
              </el-row>
              <el-row class="item-req">
                <el-col :span="18">
                  <el-input type="input" style="width: 100%;" placeholder="待发消息..." v-model="wsRequest"></el-input>
                </el-col>
                <el-col :span="3">
                    <el-select v-model="wsModel" @change="wsSelectSendModel" style="width: 100%;" placeholder="选择发送消息模板">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  <el-button @click="wsDemoSend" icon="el-icon-s-promotion">发 送</el-button>
                </el-col>
              </el-row>
            </div>
            
            <!--wesocket示例参数-->
            <div v-show="!wsDemoVisible">
              <el-row class="item-req" >
                <el-col :span="4">客户端发送</el-col>
                <el-col :span="20">
                  <div style="padding: 5px 0;font-weight: bold;">示例值:</div>
                  <div id="monaco3" class="monaco" style="height: 180px;"></div>
                  <div style="padding: 5px 0;font-weight: bold;">json字符串</div>
                </el-col>
              </el-row>
              <el-row class="item-resp">
                <el-col :span="4">服务器推动消息</el-col>
                <el-col :span="20">
                  <div style="padding: 5px 0;font-weight: bold;">示例值:</div>
                  <div id="monaco4" class="monaco"></div>
                  <div style="padding: 5px 0;font-weight: bold;">json字符串</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-card>
      </div>
      
      <div class="btn-div">
        <el-button @click="$router.back()">返回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
// import  'monaco-editor/esm/vs/language/json/monaco.contribution';

export default {
  data() {
    return {
      apiDemoVisible: false,
      wsDemoVisible: false,
      demo: {
        body: "",
        deviceid: "",
        realtime: "0",
        time: "",
        interval:"",
      },
      realtimeList: [
        {value: "1", label: "获取实时数据，realtime=1"},
        {value: "0", label: "不传realtime参数"},
      ],
      demoResponse: "",
      wsRequest: "",
      options:[],
      wsModel: "",
      websocket: null,
      wsConn: false,
      project: {},
      monaco: null,
      monaco2: null,
      monaco3: null,
      monaco4: null,
      // monaco5: null,
      // monaco6: null,
    };
  },
  methods: {
    createMonaco(dom){
      return monaco.editor.create(dom,{
        value: '',
        language: 'json',
        contextmenu: true,
        theme: 'vs-dark',
        minimap: {
          enabled: false // 不要小地图
        },
        autoIndent:true,//自动布局
        // readOnly: true,
        selectOnLineNumbers: false,
        tabSize: 2,
        automaticLayout: true,
        EditorMinimapOptions: {
            enabled: false
        },
      })
    },
    createHttpModule(){
      let _this = this;
      if(document.getElementById("monaco")){
        _this.monaco = _this.createMonaco(document.getElementById("monaco"));
      }
      if(document.getElementById("monaco2")){
        _this.monaco2 = _this.createMonaco(document.getElementById("monaco2"));
      }
      let jsonReuslt = {
        "code": 200,
        "data": {},
        "msg": ""
      }
      _this.monaco2.setValue(JSON.stringify(jsonReuslt));
    },
    createWebsocketModule(){
      let _this = this;
      if(document.getElementById("monaco3")){
        _this.monaco3 = _this.createMonaco(document.getElementById("monaco3"));
      }
      if(document.getElementById("monaco4")){
        _this.monaco4 = _this.createMonaco(document.getElementById("monaco4"));
      }

      //将属性映射转化为json
      let am = JSON.parse(_this.project.attributeMapping);
      let jsonObj = {};
      for(let obj of am){
        jsonObj[obj.apiattr] = obj.name+"";
      }

      let queryConfigStr = '{\r\n  "queryConfig":{\r\n    "pushInterval":"服务端推动 时间间隔(秒) 最低秒一次，默认1秒",\r\n    "param":{\r\n      "time":"查询起始时间,时间戳（秒）,默认当前时间",\r\n      "interval":"时间间隔（秒） time ~ time+interval 这段时间内的数据",\r\n      "deviceid":"设备ID"\r\n    }\r\n  }\r\n}'
      _this.monaco3.setValue(queryConfigStr);
      let jsonArr = new Array();
      jsonObj.stime = "数据接收时间";
      jsonArr.push(jsonObj);
      _this.monaco4.setValue(JSON.stringify({type: "query", data: jsonArr}));
      _this.options = [
        {value: "1", label:"设置推送间隔"},
        {value: "2", label:"查询指定时间数据"},
        {value: "3", label:"查询指定设备数据"},
        {value: "4", label:"查询时间间隔"}
      ];
      this.wsDemoAddOutPut(1, "点击连接开始测试吧！！！ ");

    },
    httpDemoTest(){
      let _this = this;
      
      let httpConfig = {};
      httpConfig.url = _this.project.dataUpUrl;
      httpConfig.method = "get";
      httpConfig.headers = {'Content-Type': 'application/json'};
      httpConfig.params = {
        deviceid: _this.demo.deviceid,
        realtime: _this.demo.realtime,
        time: _this.demo.time,
        interval: _this.demo.interval,
      };
      //接口测试
      this.axios(httpConfig).then(res=>{
        console.log(res);
        _this.demoResponse = JSON.stringify(res.data);
      })
      .catch(function(err){
        console.log(err);
        _this.$message({
          type: 'error',
          offset: 80,
          message: "请求出现错误！",
          center: true
        })
      })
    },
    getPageTime(){
      var myDate = new Date();	//创建Date对象
      var Y = myDate.getFullYear();   //获取当前完整年份
      var M = myDate.getMonth() + 1;  //获取当前月份
      var D = myDate.getDate();   //获取当前日1-31
      var H = myDate.getHours();  //获取当前小时
      var i = myDate.getMinutes();    //获取当前分钟
      var s = myDate.getSeconds();    //获取当前秒数
      // 月份不足10补0
      if(M < 10){
          M = '0' + M;
      }
      // 日不足10补0
      if(D < 10){
          D = '0' + D;
      }
      // 小时不足10补0
      if(H < 10){
          H = '0' + H;
      }
      // 分钟不足10补0
      if(i < 10){
          i = '0' + i;
      }
      // 秒数不足10补0
      if(s < 10){
          s = '0' +s;
      }
      // 拼接日期分隔符根据自己的需要来修改
      var nowDate = Y+'-'+M+'-'+D+' '+H+':'+i+':'+s;
      return nowDate;
    },
    wsDemoConn(){
      let _this = this;
      
      if(typeof(WebSocket) === "undefined"){
          _this.$message.error('您的浏览器不支持socket');
      }else{
        if(_this.websocket == null){
          // 实例化socket
          _this.websocket = new WebSocket(_this.project.dataUpUrl)
          // 监听socket连接
          _this.websocket.onopen = function(){
            _this.wsDemoAddOutPut(3, "连接成功，现在你可以发送信息啦！！！ ");
          }
          // 监听socket错误信息
          _this.websocket.onerror = function(){
            _this.wsDemoAddOutPut(3, "发生错误:");
          }
          _this.websocket.onclose = function(){
            _this.wsDemoAddOutPut(3, "websocket连接已断开!!! ");
          }
          // 监听socket消息
          _this.websocket.onmessage = function(evt){
            _this.wsDemoAddOutPut(2, "服务端回应 "+_this.getPageTime(), evt.data);
          }
          _this.wsConn = true;
        }
      }
    },
    wsDemoClose(){
      if(this.websocket != null){
        this.websocket.close();
        this.websocket = null;
        this.wsConn = false;
      }
    },
    wsDemoClear(){
      var box=document.getElementById("wsoutput").innerHTML = "";
    },
    wsDemoSend(){
      if(!this.wsRequest || this.wsRequest.length <= 0){
        return;
      }

      if(this.websocket){
        try{
          JSON.parse(this.wsRequest);
        }catch(e){
          this.wsDemoAddOutPut(3, "消息内容异常，请检查是否为json格式");
          return;
        }
        this.websocket.send(this.wsRequest);
        this.wsDemoAddOutPut(1, "你发送的信息 "+this.getPageTime(), this.wsRequest);
      }else{
        this.wsDemoAddOutPut(3, "先连接成功后才发送消息，！！！ ", );
      }
    },
    wsSelectSendModel(val){
      if(val == "1"){
        this.wsRequest='{"queryConfig":{"pushInterval": "1"}}';
      }else if(val == "2"){
        this.wsRequest='{"queryConfig":{"param": {"time":"'+ parseInt(new Date().getTime()/1000) +'"}}}';
      }else if(val == "3"){
        this.wsRequest='{queryConfig:{param: {deviceid:""}}}';
      }else if(val == "4"){
        this.wsRequest='{"queryConfig":{"param": {"time":"'+ parseInt(new Date().getTime()/1000) +'", "interval":"5"}}}';
      }else if(val == "0"){
        let am = JSON.parse(this.project.attributeMapping);
        let jsonDemo = {};
        for(let obj of am){
          jsonDemo[obj.apiattr] = this.attrVals[obj.tabattr];
        }
        this.wsRequest=JSON.stringify({save:jsonDemo})
      }
    },
    wsDemoAddOutPut(type, msg, data){
      let color = "green";
      if(type == 1){//发送消息
        color = "green";
      }else if(type == 2){//接收消息
        color = "blue";
      }else if(type == 3){//警告类型
        color = "red";
      }
      let str = '<div class="newmessage"><span style="color: '+color+';">'+ msg +'</span>';
      if(data && data.length > 0){
        str += '<br/><span class="bubble">'+ data +'</span>'
      }
      str += '</div>'
      var box=document.getElementById("wsoutput");
      box.insertAdjacentHTML("beforeend",str);
    }
  },
  created() {
    
  },
  mounted() {
    window.vue = this
    let _this = this;
    var query = _this.$route.query;
    if(query.id != null && !(query.id === undefined) && !(query.id === "")){
      var uid = getCookieV('userid1');
      var token = getCookieV('token1');
      _this.axios({
        method: 'get',
        url: _this.api.selectDetailsByIdServerProject+"/"+query.id,
        params: {
          uid: uid,
          tk: token,
        },
      }).then(res=>{
        let data = res.data;
        if(data.code==200){
          _this.project = data.data;
          if(_this.project.type == 'http'){
            _this.createHttpModule();
          }else{
            _this.createWebsocketModule();
          }
        }else if(data.code==-1){
            window.location.href=_this.api.loginHtmlUrl;
        }
      }).catch(function(err){
        console.log(err);
        commonErrorTip(_this);
      })
    }
  },
  destroyed () {
    // 销毁
    if(this.websocket != null){
      this.websocket.close();
    }
  }
};
</script>
<style lang="scss" scoped>
.el-card__body{
  padding: 10px im;
}

.list-div {
  position: relative;
  padding: 0 0 0 30px;
  height: 850px;
  width: 90%;
  left: 80px;
}
.list-title {
  position: relative;
  // left: 15px;
  font-size: 20px;
  color: #333;
  padding: 10px;
  border-bottom: 1px solid #dadada;
}
.steps-div{
  height: 300px;
  width: 200px;
  // background-color: #ffffff;
}
.edit-div{
  height: 100%;
}

.demo-btn{
  // position: absolute;
  // right: 20px;
  float: right;
}

.form-link{
  width: 100%;
  border-bottom: 1px solid #dadada;
  margin-bottom: 22px;
  box-shadow: 0 0 2px 2px #efefef;
}

.item{
  background: rgba(73,204,144,.1);
  padding: 5px 10px;
  // margin: 10px 0;
}

.item-title{
  font-weight: bold;
  padding:5px 0;
  border-bottom:1px solid rgba(59,65,81,.2);
}

.btn-div{
  text-align: center;
  margin: 10px 15px;
}
.item-req{
  border-radius: 10px;
  padding:10px 10px;
  margin: 5px 0;
  line-height: 40px;
  background-color: #8ad376;
}
.item-resp{
  border-radius: 10px;
  padding:10px 10px;
  margin: 5px 0;
  background-color: #a2d0d1;
}

.monaco {
  width: 800px;
  height: 80px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
}

.textarea{
  width: 800px;
}

.paran-input{
  width: 500px;
}

.ws-response-div{
  border:1px solid #ccc;
  height:365px;
  overflow: auto;
  padding: 10px;
}
.newmessage{
  width: 100%;
}
.bubble{
  max-width: 240px;
  word-wrap: break-word;
  text-align: left;
  margin-left: 16px;
  margin-right: 16px;
  border-radius: 9px;
}

.table{
  border-collapse:collapse;
}
.table tr{
}
.table tr td,th{
  padding: 2px;
  border: 1px solid #ebeef5;
}
</style>